<mat-card class="files-card">
  <mat-card-title class="grid-item-title">
    {{ 'certificate.certificates' | transloco }}
  </mat-card-title>

  <mat-card-content class="table-container-wide">

    <div *ngIf="certificates && certificates.length > 0">
      <div class="certificates-container">
        <mat-label class="certificates-header">{{ 'certificate.headers.certificateType' | transloco }}</mat-label>
        <mat-label class="certificates-header">{{ 'certificate.headers.name' | transloco }}</mat-label>
        <mat-label class="certificates-header">{{ 'certificate.headers.validityPeriod' | transloco }}</mat-label>
        <mat-label class="certificates-header">{{ 'certificate.headers.comment' | transloco }}</mat-label>
        <mat-label class="certificates-header"></mat-label>
        <mat-label class="certificates-header"></mat-label>

        <ng-container *ngFor="let certificate of certificates; let i = index">

          <ng-container *ngIf="!hideEdit">
            <mat-form-field appearance="outline">
              <mat-select [(ngModel)]="certificate.certificateTypeId" [disabled]="!canEditForm">
                <mat-option>{{ 'common.text.noSelection' | transloco }}</mat-option>
                <mat-option *ngFor="let certificateType of certificateTypes" [value]="certificateType.id">{{ certificateType.name }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field #formFieldInput appearance="outline"
              class="name-input-container">
              <input matInput class="name-input" [(ngModel)]="certificate.name" (paste)="resizeInput(i)" (cut)="resizeInput(i)"
                (input)="resizeInput(i)" (change)="onNameEditClicked(i)"
                (click)="setCurrentNameBeforeChange(certificates, i)" [disabled]="!canEditForm">
              <mat-icon matPrefix class="edit-name-icon">edit</mat-icon>
              <mat-icon matSuffix class="error-name-icon" *ngIf="certificate.name.length === 0">error</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="outline" class="date-range-field">
              <mat-date-range-input [rangePicker]="picker" [disabled]="!canEditForm">
                <input matStartDate [(ngModel)]="certificate.validFrom" placeholder="{{'certificate.startDate'| transloco}}">
                <input matEndDate [(ngModel)]="certificate.validUntil" placeholder="{{'certificate.endDate'| transloco}}">
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>

            <mat-form-field #formFieldInput appearance="outline"
              class="comment-input-container">
              <input matInput class="comment-input" [(ngModel)]="certificate.comment" [disabled]="!canEditForm" />
              <mat-icon matPrefix class="edit-name-icon">edit</mat-icon>
            </mat-form-field>

            <button mat-icon-button (click)="onViewPdfClick(certificate)" color="primary" type="button"
              matTooltip="{{ 'certificate.tooltips.viewCertificate' | transloco }}">
              <mat-icon>preview</mat-icon>
            </button>

            <button mat-icon-button (click)="onDeleteCertificateClick(certificate)" color="primary" [disabled]="!canEditForm"
              matTooltip="{{ 'certificate.tooltips.deleteCertificate' | transloco }}" type="button">
              <mat-icon>delete_forever</mat-icon>
            </button>

          </ng-container>
          <ng-container *ngIf="hideEdit">
            <span>
              {{ getCertificateType(certificate.certificateTypeId ?? -1) || ('common.text.noSelection' | transloco) }}
            </span>
            <span>
              {{ certificate.name }}
            </span>
            <span>
              {{ certificate.validFrom | date }} - {{ certificate.validUntil | date }}
            </span>
            <span>
              {{ certificate.comment }}
            </span>
            <button mat-icon-button (click)="onViewPdfClick(certificate)" color="primary" type="button"
              matTooltip="{{ 'certificate.tooltips.viewCertificate' | transloco }}">
              <mat-icon>preview</mat-icon>
            </button>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <div *ngIf="!hideEdit">
      <input type="file" accept=".pdf" multiple (change)="onUploadPdfsClick(hiddenFileInput.files)" #hiddenFileInput
        onclick="value=null" style="display: none" />

      <button mat-raised-button (click)="hiddenFileInput.click()" color="primary" class="custom-button-top"
        [disabled]="!canEditForm || maxCountReached" type="button"
        matTooltip="{{ 'certificate.tooltips.uploadCertificate' | transloco }}">
        <mat-icon class="material-icons left">add</mat-icon>
        {{ 'certificate.uploadCertificateButton' | transloco }}
      </button>
    </div>

  </mat-card-content>
</mat-card>
